import gql from "graphql-tag";

export const getClientsByBroker = gql`
  query getClientsByBroker(
    $brokerId: String!
    $token: String!
    $userType: String!
    $status: String!
  ) {
    getClientsByBroker(
      brokerId: $brokerId
      token: $token
      userType: $userType
      status: $status
    ) {
        id
        scd_name
        scd_surname
        scd_email
        date_created
        scd_clientType
        scd_registered
        invite_sent
        app_info_complete
        status
        date_modified
        
        
    }
  }
`;






// WEBPACK FOOTER //
// ./src/queries/clientsByBroker.js